export default {
  NewCarOptionAdd: 'قابلیت جدید اضافه شد',
  NewCarFeatureAdd: 'ویژگی خودرو اضافه شد',
  RemoveCarFeature: 'قابلیت خودرو حذف شد',
  RemoveCarOption: 'قابلیت خودرو حذف شد',
  UpdateCarOption: 'آپشن خودرو بروزرسانی شد',
  UpdateCarFeature: 'ویژگی خودرو بروزرسانی شد',
  UpdateCarModel: 'نوع خودرو بروزرسانی شد',
  NewCarModelAdd: 'مدل جدیدی از خودرو اضافه شد',
  NewCarAdd: 'خودرو جدید اضافه شد',
  UpdateCar: 'خودرو بروزرسانی شد',
  RemoveCar: 'خودرو حذف شد',

  Amount: 'میزان',
  AmountWeight: 'میزان وزن',
  UnitWeight: 'واحد وزن',
  AmountCapacity: 'ظرفیت وزن',
  UnitCapacity: 'واحد ظرفیت',
  UnitDimension: 'واحد ابعاد',
  CarAbility: 'قابلیت خودرو ها',
  Car: 'خودرو',
  CarModel: 'نوع خودرو',
  MachineProduction: 'سال تولید خودرو',
  Color: 'رنگ',
  Character: 'حرف',
  CarFeature: 'قابلیت خودرو',
  Capacity: 'ظرفیت',
  CarHeight: 'ارتفاع خودرو',
  CapacityThreshold: 'بازه ظرفیت',
  CarWidth: 'عرض خودرو',
  CarLength: 'طول خودرو',
  Cars: 'خودرو ها',
  Driver: 'راننده',
  driverId: 'شناسه راننده',
  DriverName: 'نام راننده',
  Dimension: 'ابعاد',
  Disable: 'غیر فعال',
  DimensionWidthThreshold: ' ابعاد بازه عرض',
  DriverIsLaborer: 'راننده کارگر است',
  Description: 'توضیحات',
  Feature: 'قابلیت',
  Enable: 'فعال',
  Order: 'ترتیب',
  Unit: 'واحد',
  Slug: 'Slug',
  NoThreshold: 'عدم بازه',
  Threshold: 'بازه',
  Size: 'اندازه',
  SecondCapacity: 'ظرفیت دوم',
  SecondCapacityThreshold: 'بازه ظرفیت دوم',
  Hight: 'ارتفاع',
  HeightThreshold: 'بازه ارتفاع',
  Width: 'عرض',
  WidthThreshold: 'بازه عرض',
  Image: 'عکس',
  Length: 'طول',
  LengthThreshold: 'بازه طول',
  TypeofCar: 'نوع خودرو',
  WeightThreshold: 'بازه وزن',
  IranNumber: 'سریال ایران',
  LeftNumber: 'قسمت چپ پلاک',
  LaborerCount: 'حداقل تعداد کارگر',
  LaborerCountMin: 'تعداد کارگر از',
  LaborerCountMax: 'تعداد کارگر تا',
  LaborerDescription: 'توضیحات کارگر',
  RightNumber: 'قسمت راست پلاک',
  UnitId: 'شناسه واحد',
  Plate: 'پلاک',
  Weight: 'وزن',
  ProductionYear: 'سال تولید',
  NavCode: 'کد ناوگان',
  Brand: 'برند خودرو',

  plateNumber1: 'بخش اول پلاک',
  plateNumber2: 'بخش دوم پلاک',
  plateNumber3: 'بخش سوم پلاک',
  plateNumber4: 'بخش چهارم پلاک',
  cars: 'خودرو ها',
  brand: 'برند',
  productionYear: 'سال تولید',
  iranNumber: 'سریال ایران',
  rightNumber: 'قسمت راست پلاک',
  leftNumber: 'قسمت چپ پلاک',
  character: 'حرف',
  carModel: 'نوع خودرو',
  color: 'رنگ',
  machineProduction: 'سال تولید خودرو',
  plate: 'پلاک',
  navCode: 'کد ناوگان',
  vehicleId: 'شناسه خودرو',
  carModelId: 'شناسه نوع خودرو',
  carFeatureId: 'شناسه نوع خودرو',
  carLoadId: 'شناسه بارگیر',
  carLoads: 'بارگیرها',
  carBrandId: 'شناسه برند',
  employeeId: 'شناسه افراد',
  itemGroupId: 'شناسه گروه اقلام',
  itemId: 'شناسه خانواده اقلام',
  itemFeatureId: 'شناسه نوع اقلام',
  loadId: 'شناسه نوع بار',
  packageId: 'شناسه بسته بندی',
  cartonId: 'شناسه کارتن',
  cancelId: 'شناسه کنسلی',
  organizationId: 'شناسه سازمان',
  feedbackId: 'شناسه بازخورد',
  referrerTypeId: 'شناسه نوع معرف',
  userGroupId: 'شناسه گروه کاربران',
  userLevelId: 'شناسه سطح کاربران',
  departmentId: 'شناسه دپارتمان',
  mediaId: 'شناسه رسانه تماس',
  categoryId: 'شناسه دسته تماس',
  subCategoryId: 'شناسه زیر دسته تماس',
  subjectId: 'شناسه موضوع',
  bankId: 'شناسه بانک',
  bankAccountId: 'شناسه حساب بانک',
  policyId: 'شناسه سیاست',
  distanceFactor: 'ضریب مسافت',
  inputFactor: 'ضریب ورودی',
  personalCar: 'خودرو شخصی',
  otherCars: 'سایر خودروها',
  isVip: 'وی‌آی‌پی است'
}
